import config from '../config';

export default {
  ...config,
  appUrl: '/e', // Without trailing slash
};
